const QUERY_OPTIONS = { next: { revalidate: 30 } };

export default QUERY_OPTIONS;
